/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomFieldReference
 */
export interface CustomFieldReference {
    /**
     * 
     * @type {number}
     * @memberof CustomFieldReference
     */
    id: number;
    /**
     * 
     * @type {Array<{ [key: string]: string | undefined; }>}
     * @memberof CustomFieldReference
     */
    readonly labels?: Array<{ [key: string]: string | undefined; }>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomFieldReference
     */
    readonly options?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldReference
     */
    readonly name?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldReference
     */
    readonly order?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldReference
     */
    readonly type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldReference
     */
    readonly useForUploads?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldReference
     */
    readonly requireToUpload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldReference
     */
    readonly nonUserEditable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldReference
     */
    readonly validation?: CustomFieldReferenceValidationEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldReference
     */
    readonly regex?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldReference
     */
    readonly rangeMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldReference
     */
    readonly rangeMax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldReference
     */
    readonly numberOfDigits?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldReference
     */
    readonly metadataPrefill?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldReference
     */
    readonly highlightExpiration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFieldReference
     */
    readonly multipleResponse?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldReference
     */
    readonly helpText?: string | null;
}

/**
* @export
* @enum {string}
*/
export enum CustomFieldReferenceValidationEnum {
    NumberOfDigits = 'number_of_digits',
    Regex = 'regex',
    Range = 'range'
}

export function CustomFieldReferenceFromJSON(json: any): CustomFieldReference {
    return CustomFieldReferenceFromJSONTyped(json, false);
}

export function CustomFieldReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomFieldReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'labels': !exists(json, 'labels') ? undefined : json['labels'],
        'options': !exists(json, 'options') ? undefined : json['options'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'order': !exists(json, 'order') ? undefined : json['order'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'useForUploads': !exists(json, 'use_for_uploads') ? undefined : json['use_for_uploads'],
        'requireToUpload': !exists(json, 'require_to_upload') ? undefined : json['require_to_upload'],
        'nonUserEditable': !exists(json, 'non_user_editable') ? undefined : json['non_user_editable'],
        'validation': !exists(json, 'validation') ? undefined : json['validation'],
        'regex': !exists(json, 'regex') ? undefined : json['regex'],
        'rangeMin': !exists(json, 'range_min') ? undefined : json['range_min'],
        'rangeMax': !exists(json, 'range_max') ? undefined : json['range_max'],
        'numberOfDigits': !exists(json, 'number_of_digits') ? undefined : json['number_of_digits'],
        'metadataPrefill': !exists(json, 'metadata_prefill') ? undefined : json['metadata_prefill'],
        'highlightExpiration': !exists(json, 'highlight_expiration') ? undefined : json['highlight_expiration'],
        'multipleResponse': !exists(json, 'multiple_response') ? undefined : json['multiple_response'],
        'helpText': !exists(json, 'help_text') ? undefined : json['help_text'],
    };
}

export function CustomFieldReferenceToJSON(value?: CustomFieldReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


